// import 'swiper/css/bundle'
// swiper core styles
import "swiper/css";
// modules styles
import "swiper/css/pagination";
import "swiper/css/navigation";

import Swiper from "swiper";
// import { Pagination, Navigation } from "swiper/modules";

const sections = document.querySelectorAll('.radial-tabs');

sections.forEach((section) => {
  const triggers = Array.from(section.querySelectorAll('.radial-tab-trigger'));
  const panels = Array.from(section.querySelectorAll('.radial-tab-panel'));

  if (!triggers.length || !panels.length) return;

  triggers.forEach((trigger) => {
    console.log()

    trigger.addEventListener('click', () => {
      if (trigger.dataset.radialTabTrigger === '1') {
        showTab1(trigger)
      }
      if (trigger.dataset.radialTabTrigger === '2') {
        showTab2(trigger)
      }
      if (trigger.dataset.radialTabTrigger === '3') {
        showTab3(trigger)
      }
      if (trigger.dataset.radialTabTrigger === '4') {
        showTab4(trigger)
      }
      if (trigger.dataset.radialTabTrigger === '5') {
        showTab5(trigger)
      }
      if (trigger.dataset.radialTabTrigger === '6') {
        showTab6(trigger)
      }
    });
  });

  const showTab1 = (trigger) => {
    const tabPanel = trigger.nextElementSibling
    const tabPanelBg = trigger.nextElementSibling.nextElementSibling

    tabPanel.classList.toggle('visible')
    trigger.classList.toggle('active')
    tabPanelBg.classList.toggle('visible')

    if (trigger.classList.contains('active')) {
      tabPanel.setAttribute("style", "transform: translate(-50%, -160%);");
      trigger.setAttribute("style", "transform: translate(-50%, -230%);");
      tabPanelBg.setAttribute("style", "top: 10%;");
    } else {
      tabPanel.setAttribute("style", "transform: translate(-50%, 0);");
      trigger.setAttribute("style", "transform: translate(-50%, 0);");
      tabPanelBg.setAttribute("style", "top: 50%;");
    }
  };

  const showTab2 = (trigger) => {
    const tabPanel = trigger.nextElementSibling
    const tabPanelBg = trigger.nextElementSibling.nextElementSibling

    tabPanel.classList.toggle('visible')
    trigger.classList.toggle('active')
    tabPanelBg.classList.toggle('visible')

    if (trigger.classList.contains('active')) {
      tabPanel.setAttribute("style", "transform: translate(0, -130%); right: -80px; top: 50%;");
      trigger.setAttribute("style", "right: -30px; top: 30px;");
      tabPanelBg.setAttribute("style", "transform: translate(-10%, -65%)");
    } else {
      tabPanel.setAttribute("style", "transform: translate(-50%, 0); top: 50%; right: 0; transform: translate(-50%, -50%);");
      trigger.setAttribute("style", "right: 0");
      tabPanelBg.setAttribute("style", "transform: translate(-50%, -50%)");
    }
  };

  const showTab3 = (trigger) => {
    const tabPanel = trigger.nextElementSibling
    const tabPanelBg = trigger.nextElementSibling.nextElementSibling

    tabPanel.classList.toggle('visible')
    trigger.classList.toggle('active')
    tabPanelBg.classList.toggle('visible')

    if (trigger.classList.contains('active')) {
      tabPanel.setAttribute("style", "transform: translate(0, 0); right: -80px; top: 330px;");
      trigger.setAttribute("style", "right: -30px; top: 270px;");
      tabPanelBg.setAttribute("style", "transform: translate(-15%, -30%)");
    } else {
      tabPanel.setAttribute("style", "top: 70%; right: 0; transform: translate(-50%, -50%);");
      trigger.setAttribute("style", "right: 0;");
      tabPanelBg.setAttribute("style", "transform: translate(-50%, -50%)");
    }
  };

  const showTab4 = (trigger) => {
    const tabPanel = trigger.nextElementSibling
    const tabPanelBg = trigger.nextElementSibling.nextElementSibling

    tabPanel.classList.toggle('visible')
    trigger.classList.toggle('active')
    tabPanelBg.classList.toggle('visible')

    if (trigger.classList.contains('active')) {
      tabPanel.setAttribute("style", "transform: translate(-50%, 160%);");
      trigger.setAttribute("style", "transform: translate(-50%, 230%);");
      tabPanelBg.setAttribute("style", "top: 90%;");
    } else {
      tabPanel.setAttribute("style", "transform: translate(-50%, 0);");
      trigger.setAttribute("style", "transform: translate(-50%, 0);");
      tabPanelBg.setAttribute("style", "top: 0");
    }
  };

  const showTab5 = (trigger) => {
    const tabPanel = trigger.nextElementSibling
    const tabPanelBg = trigger.nextElementSibling.nextElementSibling

    tabPanel.classList.toggle('visible')
    trigger.classList.toggle('active')
    tabPanelBg.classList.toggle('visible')

    if (trigger.classList.contains('active')) {
      tabPanel.setAttribute("style", "transform: translate(-20%, 0); left: 0; top: 330px;");
      trigger.setAttribute("style", "left: -10px; top: 270px;");
      tabPanelBg.setAttribute("style", "transform: translate(-85%, -30%)");
    } else {
      tabPanel.setAttribute("style", "transform: translate(90%, 0); top: 250px; left: 0;");
      trigger.setAttribute("style", "left: 0;");
      tabPanelBg.setAttribute("style", "transform: translate(-50%, -50%)");
    }
  };

  const showTab6 = (trigger) => {
    const tabPanel = trigger.nextElementSibling
    const tabPanelBg = trigger.nextElementSibling.nextElementSibling

    tabPanel.classList.toggle('visible')
    trigger.classList.toggle('active')
    tabPanelBg.classList.toggle('visible')

    if (trigger.classList.contains('active')) {
      tabPanel.setAttribute("style", "transform: translate(0, -130%); left: -80px; top: 50%;");
      trigger.setAttribute("style", "left: -30px; top: 30px;");
      tabPanelBg.setAttribute("style", "transform: translate(-90%, -65%)");
    } else {
      tabPanel.setAttribute("style", "top: 50%; left: 30%; transform: translate(-50%, -50%);");
      trigger.setAttribute("style", "left: 0;");
      tabPanelBg.setAttribute("style", "transform: translate(-50%, -50%)");
    }
  };
});


class Slider {
  constructor() {
    this.testimonials()
  }

  testimonials = () => {
    const slides = document.querySelectorAll(".slider-radial-tabs");

    slides.forEach(function (slider, index) {
      slider.classList.add("slider-radial-tabs-" + index);
      // slider.parentElement
      //   .getElementsByClassName("swiper-pagination")[0]
      //   .classList.add("swiper-pagination-" + index);
      // slider.parentElement
      //   .getElementsByClassName("swiper-button-next")[0]
      //   .classList.add("swiper-button-next-" + index);
      // slider.parentElement
      //   .getElementsByClassName("swiper-button-prev")[0]
      //   .classList.add("swiper-button-prev-" + index);

      // console.log(slider.getElementsByClassName('swiper-pagination')[0])

      new Swiper(".slider-radial-tabs-" + index, {
        // modules: [Pagination, Navigation],
        // autoHeight: true,
        slidesPerView: 1.4,
        loop: false,
        spaceBetween: 34,
        // pagination: {
        //   el: ".swiper-pagination-" + index,
        //   clickable: true
        // },
        // navigation: {
        //   nextEl: ".swiper-button-next-" + index,
        //   prevEl: ".swiper-button-prev-" + index
        // },
        // Responsive breakpoints
        breakpoints: {
          600: {
            slidesPerView: 2.4,
            // spaceBetween: 24
          },
          // 992: {
          //   slidesPerView: 3
          // },
        }
      });
    });
  }

  // heroSlider() {
  // 	$(".slider-home-hero").each(function(index, element){
  // 		$(this).addClass("slider-home-hero-" + index)

  // 		let speed = $(this).data('speed'),
  // 				autoplay_delay = $(this).data('autoplay_delay')

  // 		new Swiper(".slider-home-hero-" + index, {
  // 			modules: [Autoplay],
  // 			slidesPerView: 1,
  // 			spaceBetween: 60,
  // 			loop: true,
  // 			speed: speed,
  // 			autoplay: {
  // 				delay: autoplay_delay,
  // 				disableOnInteraction: false,
  // 			},
  // 		})
  // 	})
  // }
}

new Slider
